import { inject, Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { LinkService } from './link.provider';

@Injectable({ providedIn: 'root' })
export class SeoProvider {
	private titleProvider = inject(Title);
	private metaProvider = inject(Meta);
	private linkProvider = inject(LinkService);

	public setTitle(newTitle: string): void {
		this.titleProvider.setTitle(newTitle);
		this.metaProvider.updateTag({ property: 'og:title', content: newTitle });
	}

	public setMetaDescription(description: string): void {
		this.metaProvider.updateTag({ name: 'description', content: description });
		this.metaProvider.updateTag({ property: 'og:description', content: description });
	}

	public setMetaKeywords(keywords: string): void {
		this.metaProvider.updateTag({ name: 'keywords', content: keywords });
	}

	public setImage(image: string): void {
		this.metaProvider.updateTag({ property: 'og:image:url', content: image });
		this.metaProvider.updateTag({ name: 'image', property: 'og:image', content: image });
		this.metaProvider.updateTag({ property: 'twitter:image', content: image });
	}

	public setType(type: string): void {
		this.metaProvider.updateTag({ property: 'og:type', content: type });
	}

	public setUrl(url: string): void {
		this.linkProvider.updateCanonicalUrl(url);
		this.metaProvider.updateTag({ property: 'og:url', content: url });
	}

	public updateMetaTags(metaTags: MetaDefinition[]): void {
		metaTags.forEach((m) => this.metaProvider.updateTag(m));
	}
}
